// extracted by mini-css-extract-plugin
export var fileUpload = "_gl-1";
export var modalButton = "_gl-0";